import "firebase/auth";
import "firebase/firestore";
import firebase from "firebase/app";
import {createNewUser, loginUserAfterSignup, loginUser} from "../actions";
import {connect} from "react-redux";
import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import g from "./images/g.svg"
import {myFirebase} from "../firebase/firebase";

const background_style = {
    "position": "absolute",
    "left": "0%",
    "right": "0%",
    "top": "0%",
    "bottom": "0%",
    "background": "linear-gradient(212.27deg, #DBE9D6 -3.98%, #F6F7F9 108.26%)"
};

const g_frame_style = {
    "margin-bottom": "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const button1_style = {
    fontFamily: "Open Sans Hebrew",
    background: "#65AC45",
    borderRadius: "4px"
};

const button2_style = {
    fontFamily: "Open Sans Hebrew",
    background: "#FFFFFF",
    color: "#65AC45",
    border: "1px solid #65AC45",
    borderRadius: "4px"
};

const header_style = {
    fontFamily: "Open Sans Hebrew",
    fontWeight: "bold",
    fontSize: "32px",
    lineHeight: "47px",
    alignItems: "center",
    textAlign: "center",
    color: "#0E673F"
};

const buttons_div_style = {
    "margin": "auto",
    width: "75%"
}

class SignUp extends React.Component {
    state = {email: "", password: "Aa123456"};

    signUser = () => {
        const {dispatch} = this.props;
        const {email, password} = this.state;
        window.localStorage.setItem('RegisteredEmail', email);
        dispatch(createNewUser(email, password));
    };

    logUser = () => {
        const {dispatch} = this.props;
        const {email, password} = this.state;
        dispatch(loginUserAfterSignup(email, password));
    };

    handleEmailChange = ({target}) => {
        this.setState({email: target.value});
    };

    async getUser(email) {
        return await myFirebase.auth().fetchSignInMethodsForEmail(email);
    }

    handleParentSignup = () => {
        // for signup with google.
        if (this.props.email !== undefined) {
            window.location.assign("parentsignup");
            // for regular signup.
        } else {
            // for later use inside Promise.then function.
            const {email} = this.state;
            const f1 = this.signUser;
            const f2 = this.logUser;
            let m = this.getUser(email).then(function (method) {
                // if there's no method that is using the email, sign the email in auth db and continue.
                if ((method == null) || (method === '' || method.length === 0)) {
                    // sign user.
                    f1();
                    // log user.
                    f2();
                    // when auth state changes to logged on, continue to next page.
                    myFirebase.auth().onAuthStateChanged(user => {
                        if (user) {
                            window.location.assign("parentsignup");
                        }
                    });
                    // if there is a method that is using the email it means it's already signed.
                    // inform the user and reload the signup page.
                    // unformatted email addresses will be ignored (auth will attempt to sign them and fail).
                } else {
                    alert("כתובת מייל לא תקינה");
                    window.location.assign("signup");
                }
            });
        }
    };

    handleStudentSignup = () => {
        // for signup with google.
        if (this.props.email !== undefined) {
            window.location.assign("studentsignup");
            // for regular signup.
        } else {
            // for later use inside Promise.then function.
            const {email} = this.state;
            const f1 = this.signUser;
            const f2 = this.logUser;
            let m = this.getUser(email).then(function (method) {
                // if there's no method that is using the email, sign the email in auth db and continue.
                if ((method == null) || (method === '' || method.length === 0)) {
                    // sign user.
                    f1();
                    // log user.
                    f2();
                    // when auth state changes to logged on, continue to next page.
                    myFirebase.auth().onAuthStateChanged(user => {
                        if (user) {
                            window.location.assign("studentsignup");
                        }
                    });
                    // if there is a method that is using the email it means it's already signed.
                    // inform the user and reload the signup page.
                    // unformatted email addresses will be ignored (auth will attempt to sign them and fail).
                } else {
                    alert("כתובת מייל לא תקינה");
                    window.location.assign("signup");
                }
            });
        }
    };
    // if user got here from normal sign up, show him a text box requesting his email address.
    // if user got here from google login, and it's his first login, "Home" component will direct
    // him to this page. in this case show him the email received from google and the rest
    // of the registration is the same.
    getMailSource = () => {
        if (this.props.email === undefined) {
            return (
                <div dir="ltr">
                    <TextField
                        inputProps={{style: {textAlignLast: 'left'}}}
                        multiline
                        fullWidth
                        id="email"
                        label="הכנס כתובת מייל"
                        name="email"
                        onChange={this.handleEmailChange}/>
                </div>
            );
        } else {
            return (
                <p>{this.props.email}</p>
            );
        }
    };

    render() {
        return (
            <div style={background_style}>
                <Container Container component="main" maxWidth="xs">
                    <Box m={7}/>
                    <Typography style={header_style}>
                        הרשמה
                    </Typography>
                    <Box m={2}/>
                    <div>
                        {this.getMailSource()}
                    </div>
                    <Box m={3}/>
                    <div style={buttons_div_style}>
                        <Button
                            style={button1_style}
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={this.handleParentSignup}>
                            הרשמה כהורה
                        </Button>
                        <Box m={2}/>
                        <Button
                            style={button2_style}
                            type="button"
                            fullWidth
                            variant="contained"
                            onClick={this.handleStudentSignup}>
                            הרשמה כבייביסיטר מיוחד
                        </Button>
                    </div>
                    <Box m={2.4}/>
                    <div style={g_frame_style}>
                        <img src={g} height="310px" width="310px"/>
                    </div>
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isLoggingIn: state.auth.isLoggingIn,
        loginError: state.auth.loginError,
        isAuthenticated: state.auth.isAuthenticated,
        emailsent: state.auth.emailsent
    };
}

export default (connect(mapStateToProps)(SignUp));
